import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoaderService } from './loader.service';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private service: LoginService,
    private loaderService : LoaderService
  ) {
  }
  
  tokenKey = 'token';

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {

    this.loaderService.isLoading.next(true);

    req = req.clone({
      withCredentials: true
    });

    const token = this.service.getToken();
    if (!!token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    return next.handle(req).pipe(
      filter(event => event instanceof HttpResponse),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.loaderService.isLoading.next(false);
        } 
      }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
              if (err.status === 401) {
                this.service.logout();
                this.router.navigateByUrl('/login');
              } else if (err.status === 403) {
                this.router.navigateByUrl('/unauthorized');
              }
            }
    
            this.loaderService.isLoading.next(false);
          })
    );

  }
}
